/**
 * Максимальный тип лендинга
 * @type {string}
 */
export const MAX_LANDING_TYPE = 'max'
/**
 * Минимальный тип лендинга
 * @type {string}
 */
export const MIN_LANDING_TYPE = 'min'
/**
 * Тип лендинга только плеер
 * @type {string}
 */
export const PLAYER_LANDING_TYPE = 'player'
